import { render, staticRenderFns } from "./PercentageContainer.vue?vue&type=template&id=4585112a&scoped=true&"
import script from "./PercentageContainer.vue?vue&type=script&lang=js&"
export * from "./PercentageContainer.vue?vue&type=script&lang=js&"
import style0 from "./PercentageContainer.vue?vue&type=style&index=0&id=4585112a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585112a",
  null
  
)

export default component.exports